/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Delete_ReferencedInputs */



/**
* | output |
* | --- |
* | "This promo is referenced by reports or ledger entries — retire it instead." |
*
* @param {Promo_Delete_ReferencedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_delete_referenced = /** @type {((inputs?: Promo_Delete_ReferencedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Delete_ReferencedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cette promo est référencée dans des rapports ou des entrées du registre — retirez-la plutôt.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esta promo está referenciada en informes o entradas del registro — retírela en su lugar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Esta promo é referenciada em relatórios ou entradas do registro — retire-a em vez disso.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questa promo è referenziata in rapporti o voci del registro — ritirala invece.")
	return /** @type {LocalizedString} */ ("This promo is referenced by reports or ledger entries — retire it instead.")
});